import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* saveUserFeedbackCommitOption(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_REFUND_COMMIT_OPTION,
      API.POST,
      action.params
    );
    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.SAVE_USER_FEEDBACK_COMMIT_OPTION_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.SAVE_USER_FEEDBACK_COMMIT_OPTION_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SAVE_USER_FEEDBACK_COMMIT_OPTION_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchSaveFeedbackCommitOption() {
  yield takeLatest(
    types.SAVE_USER_FEEDBACK_COMMIT_OPTION_REQUESTED,
    saveUserFeedbackCommitOption
  );
}
